import { render } from "./profileListToDelete.vue?vue&type=template&id=4028e44c&ts=true"
import script from "./profileListToDelete.vue?vue&type=script&lang=ts"
export * from "./profileListToDelete.vue?vue&type=script&lang=ts"

import "./profileListToDelete.vue?vue&type=style&index=0&id=4028e44c&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__